import loadable from '@loadable/component';
import Loading from '../components/Loader';

const BunningsLanding = loadable(
  () => import(/* webpackChunkName: "bunningsLanding" */ '../pages/BunningsLanding'),
  {
    fallback: Loading
  }
);

export default BunningsLanding;
